export interface SICMajorGroup {
  code: string
  description: string
  category: string
}

// 2-digit SIC Major Groups (based on OSHA SIC Manual, 1987)
export const SIC_CODES: SICMajorGroup[] = [
  // Agriculture, Forestry, and Fishing
  { code: "01", description: "Agricultural Production - Crops", category: "Agriculture" },
  { code: "02", description: "Agricultural Production - Livestock", category: "Agriculture" },
  { code: "07", description: "Agricultural Services", category: "Agriculture" },
  { code: "08", description: "Forestry", category: "Agriculture" },
  { code: "09", description: "Fishing, Hunting, and Trapping", category: "Agriculture" },

  // Mining
  { code: "10", description: "Metal Mining", category: "Mining" },
  { code: "12", description: "Coal Mining", category: "Mining" },
  { code: "13", description: "Oil and Gas Extraction", category: "Mining" },
  { code: "14", description: "Nonmetallic Minerals, Except Fuels", category: "Mining" },

  // Construction
  { code: "15", description: "General Building Contractors", category: "Construction" },
  { code: "16", description: "Heavy Construction, Except Building", category: "Construction" },
  { code: "17", description: "Special Trade Contractors", category: "Construction" },

  // Manufacturing
  { code: "20", description: "Food and Kindred Products", category: "Manufacturing" },
  { code: "21", description: "Tobacco Products", category: "Manufacturing" },
  { code: "22", description: "Textile Mill Products", category: "Manufacturing" },
  { code: "23", description: "Apparel and Other Textile Products", category: "Manufacturing" },
  { code: "24", description: "Lumber and Wood Products", category: "Manufacturing" },
  { code: "25", description: "Furniture and Fixtures", category: "Manufacturing" },
  { code: "26", description: "Paper and Allied Products", category: "Manufacturing" },
  { code: "27", description: "Printing and Publishing", category: "Manufacturing" },
  { code: "28", description: "Chemicals and Allied Products", category: "Manufacturing" },
  { code: "29", description: "Petroleum and Coal Products", category: "Manufacturing" },
  { code: "30", description: "Rubber and Miscellaneous Plastics Products", category: "Manufacturing" },
  { code: "31", description: "Leather and Leather Products", category: "Manufacturing" },
  { code: "32", description: "Stone, Clay, and Glass Products", category: "Manufacturing" },
  { code: "33", description: "Primary Metal Industries", category: "Manufacturing" },
  { code: "34", description: "Fabricated Metal Products", category: "Manufacturing" },
  { code: "35", description: "Industrial Machinery and Equipment", category: "Manufacturing" },
  { code: "36", description: "Electronic and Other Electric Equipment", category: "Manufacturing" },
  { code: "37", description: "Transportation Equipment", category: "Manufacturing" },
  { code: "38", description: "Instruments and Related Products", category: "Manufacturing" },
  { code: "39", description: "Miscellaneous Manufacturing Industries", category: "Manufacturing" },

  // Transportation, Communications, Utilities
  { code: "40", description: "Railroad Transportation", category: "Transportation" },
  { code: "41", description: "Local and Interurban Passenger Transit", category: "Transportation" },
  { code: "42", description: "Trucking and Warehousing", category: "Transportation" },
  { code: "43", description: "U.S. Postal Service", category: "Transportation" },
  { code: "44", description: "Water Transportation", category: "Transportation" },
  { code: "45", description: "Transportation by Air", category: "Transportation" },
  { code: "46", description: "Pipelines, Except Natural Gas", category: "Transportation" },
  { code: "47", description: "Transportation Services", category: "Transportation" },
  { code: "48", description: "Communications", category: "Communications" },
  { code: "49", description: "Electric, Gas, and Sanitary Services", category: "Utilities" },

  // Wholesale Trade
  { code: "50", description: "Wholesale Trade - Durable Goods", category: "Wholesale Trade" },
  { code: "51", description: "Wholesale Trade - Nondurable Goods", category: "Wholesale Trade" },

  // Retail Trade
  { code: "52", description: "Building Materials and Garden Supplies", category: "Retail Trade" },
  { code: "53", description: "General Merchandise Stores", category: "Retail Trade" },
  { code: "54", description: "Food Stores", category: "Retail Trade" },
  { code: "55", description: "Automotive Dealers and Service Stations", category: "Retail Trade" },
  { code: "56", description: "Apparel and Accessory Stores", category: "Retail Trade" },
  { code: "57", description: "Furniture and Home Furnishings Stores", category: "Retail Trade" },
  { code: "58", description: "Eating and Drinking Places", category: "Retail Trade" },
  { code: "59", description: "Miscellaneous Retail", category: "Retail Trade" },

  // Finance, Insurance, and Real Estate
  { code: "60", description: "Depository Institutions", category: "Finance" },
  { code: "61", description: "Nondepository Institutions", category: "Finance" },
  { code: "62", description: "Security and Commodity Brokers", category: "Finance" },
  { code: "63", description: "Insurance Carriers", category: "Finance" },
  { code: "64", description: "Insurance Agents, Brokers, and Service", category: "Finance" },
  { code: "65", description: "Real Estate", category: "Finance" },
  { code: "67", description: "Holding and Other Investment Offices", category: "Finance" },

  // Services
  { code: "70", description: "Hotels and Other Lodging Places", category: "Services" },
  { code: "72", description: "Personal Services", category: "Services" },
  { code: "73", description: "Business Services", category: "Services" },
  { code: "75", description: "Auto Repair, Services, and Parking", category: "Services" },
  { code: "76", description: "Miscellaneous Repair Services", category: "Services" },
  { code: "78", description: "Motion Pictures", category: "Services" },
  { code: "79", description: "Amusement and Recreation Services", category: "Services" },
  { code: "80", description: "Health Services", category: "Services" },
  { code: "81", description: "Legal Services", category: "Services" },
  { code: "82", description: "Educational Services", category: "Services" },
  { code: "83", description: "Social Services", category: "Services" },
  { code: "84", description: "Museums, Botanical, Zoological Gardens", category: "Services" },
  { code: "86", description: "Membership Organizations", category: "Services" },
  { code: "87", description: "Engineering and Management Services", category: "Services" },
  { code: "88", description: "Private Households", category: "Services" },
  { code: "89", description: "Services, Not Elsewhere Classified", category: "Services" },

  // Public Administration & Other
  { code: "91", description: "Executive, Legislative, and General", category: "Public Administration" },
  { code: "92", description: "Justice, Public Order, and Safety", category: "Public Administration" },
  { code: "93", description: "Finance, Taxation, and Monetary Policy", category: "Public Administration" },
  { code: "94", description: "Administration of Human Resources", category: "Public Administration" },
  { code: "95", description: "Environmental Quality and Housing", category: "Public Administration" },
  { code: "96", description: "Administration of Economic Programs", category: "Public Administration" },
  { code: "97", description: "National Security and International Affairs", category: "Public Administration" },
  { code: "99", description: "Nonclassifiable Establishments", category: "Other" },
]

export const SIC_CATEGORIES: string[] = [
  "All",
  ...Array.from(new Set(SIC_CODES.map((c) => c.category))).sort(),
]


